import { api_signup_user_path, create_user_path } from '@routes';

import request from './request';

export enum LeadType {
  SUBSCRIBE_PAGE = 'subscribe_page_lead',
  SUBSCRIBE_H_PAGE = 'subscribe_h_page_lead',
  REFERRAL_PAGE = 'referral_page_lead',
}

export interface CreateUserParams {
  code: string;
  dob?: string;
  email: string;
  form_location: string;
  lead_type: LeadType;
  name: string;
  page: string;
  recaptcha_token: string;
  referring_article_id?: string;
}

export interface CreateUserResponse {
  email: string;
  stripeCustomerId: string;
  userId: number;
}

export interface userCreateParams {
  user: { email: string; skipVerifyTeamDomain: boolean; redirect_to_on_success?: string };
}

export async function createUser(params: CreateUserParams): Promise<CreateUserResponse> {
  const response = await request('post', api_signup_user_path(params));
  return response;
}

export async function createTeamUser(params) {
  const resp = await request('post', create_user_path(params));
  return resp;
}
